export const BUSINESS_TYPES = ["Transporter", "Truck Owner", "Fleet Owner", "Dealer", "Workshop", "Petrol Pump", "Other"];
export const PRODUCT_OPTIONS = ["TATA DEF 20 L Bucket", "Gulf AdBlue 20 L Bucket", "AdBlue IBC Tank (1000 L)", "AdBlue — Loose / Bulk", "Lubricating Oils", "Other"];
export const STATES = ["West Bengal", "Odisha", "Jharkhand", "Bihar", "Assam", "Uttar Pradesh", "Other"];
export const MOBILE_ATTRS = { pattern: "(\\+?91)?[6-9][0-9]{9}", title: "Enter a valid 10-digit Indian mobile number (digits only)", inputMode: "tel", maxLength: 13 };
export const BULK_PRODUCTS = ["Tata Motors DEF", "Gulf AdBlue", "Eicher AdBlue", "BharatBenz DEF", "DEF Buckets", "DEF IBC Tanks"];
export const QTY_UNITS = ["Litres", "Buckets", "IBC Tanks"];

export const LEAD_FIELDS = {
  name: { name: "name", label: "Your name", required: true },
  phone: { name: "phone", label: "Mobile number", type: "tel", required: true, placeholder: "10-digit mobile number", attrs: MOBILE_ATTRS },
  whatsapp: { name: "whatsapp", label: "WhatsApp number", type: "tel", placeholder: "If different from mobile", attrs: MOBILE_ATTRS },
  email: { name: "email", label: "Email", type: "email" },
  company: { name: "company", label: "Company / Business name" },
  business_type: { name: "business_type", label: "Business type", type: "select", options: BUSINESS_TYPES },
  city: { name: "city", label: "City / Town", required: true },
  state: { name: "state", label: "State", type: "select", options: STATES },
  product: { name: "product", label: "Product interested in", type: "select", options: PRODUCT_OPTIONS },
  quantity: { name: "quantity", label: "Required quantity", placeholder: "e.g. 50 buckets / 2000 L" },
  message: { name: "message", label: "Message", type: "textarea", full: true },
};

export const pick = (...keys) => keys.map((k) => (typeof k === "string" ? LEAD_FIELDS[k] : k));
